export default __webpack_public_path__ + "static/media/uzbekistan.f5d6f164.svg";